import React from 'react';
import {widgetProps} from '../widgets/common';
import {ResourceDiffWidget} from '../widgets/ResourceDiffWidget';
import {useSchema} from '../hooks/useSchema';
import {DiffField} from '../widgets/diff/DiffField';
import {FieldOutputProps} from '../field/DetailsFieldValue';
import {Spinner} from '../common/Spinner';
import {PARAM_KEY_FOR} from '../consts';

type Props = FieldOutputProps;

export const ResourceDiffField: React.FC<Props> = (props) => {
  const schema = useSchema(props.field.itemType!, {[PARAM_KEY_FOR]: 'diff'});
  const fields = widgetProps<DiffField[]>(props.field, 'fields', []);

  if (!schema) {
    return <Spinner />;
  }

  const oldDataFieldId = widgetProps(
    props.field,
    'old_data_field_id',
    'old_data',
  );

  const oldData = JSON.parse(props.item[oldDataFieldId]);

  const newDataFieldId = widgetProps(
    props.field,
    'new_data_field_id',
    'new_data',
  );

  const newData = JSON.parse(props.item[newDataFieldId]);

  return (
    <ResourceDiffWidget
      {...props}
      schema={schema}
      fields={fields}
      diff={JSON.parse(props.value)}
      oldData={oldData}
      newData={newData}
    />
  );
};
